import React from "react";
import SideBar from "../Components/sidebar";
import Header from "../Components/header";
import { Outlet } from "react-router-dom";

const AdminLayout = ({ children }) => {
    return (
        <div className="flex h-screen">
            {/* Sidebar */}
            <SideBar role="vendor" />

            <div className="flex-1 flex flex-col">
                {/* Header */}
                <Header role="vendor" />

                {/* Main Content Area */}
                <main className="p-4 mt-10 lg:mt-0 bg-[#FFFFFF] lg:pl-[265px] pl-0 transition-all duration-300">
                    {/* Content rendered by Outlet */}
                    <Outlet />
                </main>
            </div>
        </div>



    );
};

export default AdminLayout;
